import { api } from './client'
import type { User } from '../types'

export interface Group {
  id: string
  name: string
  description: string
  is_public: boolean
  slow_mode_secs: number
  member_count: number
  created_at: string
}

export interface GroupMember {
  user_id: string
  role: 'owner' | 'admin' | 'member'
  user?: User
}

export const groupsApi = {
  create: (data: { name: string; description?: string; is_public?: boolean }): Promise<Group> =>
    api.post('/v1/groups/', data),

  get: (groupId: string): Promise<Group> =>
    api.get(`/v1/groups/${groupId}`),

  addMember: (groupId: string, userId: string) =>
    api.post(`/v1/groups/${groupId}/members`, { user_id: userId }),

  leave: (groupId: string) =>
    api.delete(`/v1/groups/${groupId}/leave`),

  listMembers: (groupId: string): Promise<{ members: GroupMember[] }> =>
    api.get(`/v1/groups/${groupId}/members`),

  kick: (groupId: string, userId: string) =>
    api.delete(`/v1/groups/${groupId}/members/${userId}`),

  updateRole: (groupId: string, userId: string, role: 'admin' | 'member') =>
    api.patch(`/v1/groups/${groupId}/members/${userId}/role`, { role }),

  createInvite: (groupId: string): Promise<{ code: string; url: string }> =>
    api.post(`/v1/groups/${groupId}/invites`, {}),

  joinViaInvite: (code: string): Promise<{ group_id: string }> =>
    api.post(`/v1/groups/join/${encodeURIComponent(code)}`, {}),

  listInvites: (groupId: string): Promise<{ links: Array<{ code: string; url: string; created_at: string }> }> =>
    api.get(`/v1/groups/${groupId}/invites`),

  revokeInvite: (groupId: string, code: string): Promise<void> =>
    api.delete(`/v1/groups/${groupId}/invites/${encodeURIComponent(code)}`),

  update: (groupId: string, data: { name?: string; description?: string; is_public?: boolean; slow_mode_secs?: number }): Promise<Group> =>
    api.patch(`/v1/groups/${groupId}`, data),
}
